import {
  TransactionItemComponentType,
  TransactionItemDateFormatType,
} from '@/context/services/transaction_items/List/TransactionItems.service';
import { ComponentTypeMap } from '@/features/transaction_items/components/Form/GeneralForm/TransactionItemGeneralForm';

export type TransactionItemsColumn = {
  id: string;
  label: string;
  type: 'basic' | 'custom' | undefined;
  component_type: string;
  ref_label: string;
  ref_link: string;
  is_visible: boolean;
  priority: number;
  system_tooltip: string | undefined;
  date_format_type?: TransactionItemDateFormatType | undefined;
  can_delete?: boolean;
  delete_tooltip?: string;
};

export const TransactionItemComponent = {
  [TransactionItemComponentType.text]: 'transaction_items.table.text',
  [TransactionItemComponentType.alphanumeric]:
    'transaction_items.table.alphanumeric',
  [TransactionItemComponentType.pulldown]: 'transaction_items.table.pulldown',
  [TransactionItemComponentType.date]: 'transaction_items.table.date',
  [TransactionItemComponentType.price]: 'transaction_items.table.price',
  [TransactionItemComponentType.checkbox]: 'transaction_items.table.checkbox',
  [TransactionItemComponentType.numeric]: 'transaction_items.table.numeric',
};

export type ComponentType = keyof typeof ComponentTypeMap | undefined;

export type TransactionItemFormType = {
  label: string;
  is_visible?: boolean;
  component_type: ComponentType;
  max_chars?: number;
  min_chars?: number;
  min_value?: string;
  max_value?: string;
  allow_decimal?: boolean;
  placeholder?: string;
  date_format_type?: TransactionItemDateFormatType | undefined;
  tooltip_message?: string;
};

export const TransactionGeneralFormMode = {
  create: 'create',
  edit: 'edit',
};

export type TransactionItemDrawerMode = TransactionItemDrawerModeEnum | null;

export enum TransactionItemDrawerModeEnum {
  CREATE = 'create',
  EDIT = 'edit',
  DETAIL = 'detail',
}
